// ============================================================
// HIS BROTHERS AROUND HIM (Squad Mode stage 8): for the B-scope - each
// other brother of his kill-team on the stage, with the metres and the
// bearing to him from the map's markers; null for one off the map (the
// instrument names him in its header instead). Bearing: 0 up the map
// (-z), clockwise.
//
// Pure. Zero React dependency.
// ============================================================
import type { Combatant } from '../roster/types';
import { teamOf } from '../roster/team';
import { brothersIn } from './record';
import type { Brother } from '../plate/bscope';

export function brothersAround(
  roster: readonly Combatant[],
  tokens: Readonly<Record<string, { x: number; z: number }>>,
  id: string,
): Brother[] {
  const me = roster.find((c) => c.id === id);
  const tag = me && teamOf(me)?.tag;
  if (!me || !tag) return [];
  const at = tokens[id];
  return brothersIn(roster, tag)
    .filter((b) => b.id !== id)
    .map((b) => {
      const there = tokens[b.id];
      if (!at || !there) return { id: b.id, name: b.name, metres: null, bearing: null };
      const dx = there.x - at.x;
      const dz = there.z - at.z;
      return { id: b.id, name: b.name, metres: Math.hypot(dx, dz), bearing: Math.atan2(dx, -dz) };
    });
}

/**
 * Where the brothers of kill-teams with an Oath stand, as one string: it changes when a brother moves and only then, so a
 * plate's B-scope redraws on his move and on no one else's (the stage 8 review).
 */
export function brotherPositionsKey(
  roster: readonly Combatant[],
  tokens: Readonly<Record<string, { x: number; z: number }>>,
  tags: readonly string[],
): string {
  return tags
    .flatMap((tag) => brothersIn(roster, tag))
    .map((b) => (tokens[b.id] ? `${b.id}@${tokens[b.id].x},${tokens[b.id].z}` : b.id))
    .join('|');
}
